import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-store-info-bar',
  templateUrl: './store-info-bar.component.html',
  styleUrls: ['./store-info-bar.component.scss']
})
export class StoreInfoBarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
